// extracted by mini-css-extract-plugin
module.exports = {"wordBreakStyle":"DataExpressionReview_wordBreakStyle__2iJLl"};